import { buildUrl, paths } from "@/api/url";
import { http } from "@/lib/http";

/**
 * Mirrors the Daraja.Accessibility_settings table
 */
export interface AccessibilitySettingsDTO {
  user_id: string;
  username?: string;

  zoom_level: number;
  high_contrast: boolean;
  underline_links: boolean;
  text_spacing: boolean;

  reduce_motion: boolean;

  keyboard_navigation: boolean;
  focus_indicators: boolean;

  cursor_size: string;

  tts: boolean;
  speech_rate: number;
  tts_on_focus: boolean;
  tts_on_hover: boolean;

  screen_reader_optimization: boolean;
  dyslexia_friendly_font: boolean;
}

/**
 * Fetch accessibility settings for a given user
 *
 * Returns null if no settings exist yet.
 */
export async function getAccessibilitySettings(
  userId: string
): Promise<AccessibilitySettingsDTO | null> {
  const response = await http.get<AccessibilitySettingsDTO>(
    buildUrl(paths.v1.accessibilityByUser(userId))
  );

  return response.data ?? null;
}

/**
 * Save or update accessibility settings
 */
export async function saveAccessibilitySettings(payload: AccessibilitySettingsDTO): Promise<void> {
  await http.post(buildUrl(paths.v1.saveAccessibilitySettings()), payload);
}
``;
